/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Grid from "@mui/material/Grid";
import summaryStyle from "../../../Common/Style/summaryStyle";
import GridEditRow from "../../../Common/GridEditRow/GridEditRow";
import Typography from "@mui/material/Typography";
import { momentToGermanDate } from "../../../../../services/formatService";
import { AbstractCase } from "../../../../../types/Entities/AbstractCase";
import { Box } from "@mui/material";

type AlimonyDataProps = {
  formData: AbstractCase | Record<string, any>;
  basePath: string;
};

const AlimonyData = ({ formData, basePath }: AlimonyDataProps) => {
  const formPath = basePath + "/angaben-zum-unterhalt";
  const section = "alimony";
  return (
    <>
      <Grid item xs={12} sx={summaryStyle.subHeadline}>
        <Typography variant={"h5"}>{formData.basicChoice === "complete" ? "Heirat und Trennung" : "Familiäre Situation"}</Typography>
      </Grid>
      {formData.basicChoice === "complete" && (
        <>
          <Grid item xs={12} sx={summaryStyle.question}>
            <Box id={"dateMarriage"} sx={summaryStyle.scrollToAnchor} />
            Datum standesamtliche Heirat
          </Grid>
          <GridEditRow
            item
            xs={12}
            to={{
              pathname: formPath,
              state: {
                section: section,
                field: "dateMarriage",
              },
            }}
          >
            {momentToGermanDate(formData.dateMarriage)}
          </GridEditRow>
        </>
      )}

      <Grid item xs={12} sx={summaryStyle.question}>
        <Box id={"areSeparated"} sx={summaryStyle.scrollToAnchor} />
        Sind Sie getrennt?
      </Grid>
      <GridEditRow
        item
        xs={12}
        to={{
          pathname: formPath,
          state: {
            section: section,
            field: "areSeparated",
          },
        }}
      >
        {formData.areSeparated ? "Ja" : "Nein"}
      </GridEditRow>

      {formData.areSeparated && (
        <>
          <Grid item xs={12} sx={summaryStyle.question}>
            <Box id={"dateSeparation"} sx={summaryStyle.scrollToAnchor} />
            Datum der Trennung
          </Grid>
          <GridEditRow
            item
            xs={12}
            to={{
              pathname: formPath,
              state: {
                section: section,
                field: "dateSeparation",
              },
            }}
          >
            {momentToGermanDate(formData.dateSeparation)}
          </GridEditRow>
        </>
      )}

      {formData.basicChoice === "complete" && (
        <>
          <Grid item xs={12} sx={summaryStyle.question}>
            <Box id={"areDivorced"} sx={summaryStyle.scrollToAnchor} />
            Sind Sie geschieden?
          </Grid>
          <GridEditRow
            item
            xs={12}
            to={{
              pathname: formPath,
              state: {
                section: section,
                field: "areDivorced",
              },
            }}
          >
            {formData.areDivorced ? "Ja" : "Nein"}
          </GridEditRow>

          {formData.areDivorced && (
            <>
              <Grid item xs={12} sx={summaryStyle.question}>
                <Box id={"dateDivorce"} sx={summaryStyle.scrollToAnchor} />
                Datum der Scheidung
              </Grid>
              <GridEditRow
                item
                xs={12}
                to={{
                  pathname: formPath,
                  state: {
                    section: section,
                    field: "dateDivorce",
                  },
                }}
              >
                {momentToGermanDate(formData.dateDivorce)}
              </GridEditRow>
            </>
          )}
        </>
      )}

      <Grid item xs={12} sx={summaryStyle.question}>
        <Box id={"numberOfChildren"} sx={summaryStyle.scrollToAnchor} />
        Anzahl aller Kinder
      </Grid>
      <GridEditRow
        item
        xs={12}
        to={{
          pathname: formPath,
          state: {
            section: section,
            field: "numberOfChildren",
          },
        }}
      >
        {formData.numberOfChildren}
      </GridEditRow>
    </>
  );
};

export default AlimonyData;
